module.exports = "/_next/static/pages/testformat/7bcdae657f108950a583a0e1d0affbab.png";